import Model from "../Model";

class Comercialidtops extends Model{

    buildUrl ({ param }) {
        return ['/zoneview/topuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Comercialidtops;